import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { FirstnameSVG } from '@common_components/svg/firstname.svg';

const FirstnameIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <FirstnameSVG/>
    </div>
  );
};

export { FirstnameIcon };
